module.exports = __webpack_public_path__ + "static/media/ban.7bafb388.svg";